var module;
// LICENSE_CODE ZON
'use strict'; /*jslint node:true, browser:true, es6:true*/
(function () {
  var is_node = typeof module == 'object' && module.exports && module.children;
  if (!is_node) ;else ;
  define(['/util/util.js', 'events'], (_, EventEmitter) => {
    var RECURSIVE = '.';
    var E = new EventEmitter();
    E.state = {};
    E.on = (path, fn, opt) => {
      opt = Object.assign({
        recursive: false,
        init: true
      }, opt);
      EventEmitter.prototype.on.call(E, path, fn);
      if (opt.recursive) EventEmitter.prototype.on.call(E, RECURSIVE + path, fn);
      if (opt.init) fn(E.get(path));
      return {
        path,
        fn,
        recursive: opt.recursive
      };
    };
    E.off = listener => {
      EventEmitter.prototype.removeListener.call(E, listener.path, listener.fn);
      if (listener.recursive) {
        EventEmitter.prototype.removeListener.call(E, RECURSIVE + listener.path, listener.fn);
      }
    };
    E.get = path => _.get(E.state, path);
    E.set = (path, curr, opt) => {
      opt = Object.assign({
        force_emit: false
      }, opt);
      if (!opt.force_emit && _.get(E.state, path) === curr) return;
      _.set(E.state, path, curr);
      E.emit_path(path);
      // XXX colin/ilgiz: add recurisve notify when using recursive flag
    };
    E.delete = path => E.set(path, undefined);
    E.emit_path = path => {
      E.emit(path, _.get(E.state, path));
      path = path.split('.');
      while (path.length > 1) {
        path.pop();
        var p = path.join('.');
        E.emit(RECURSIVE + p, _.get(E.state, p));
      }
    };
    E.clear = function () {
      this.removeAllListeners();
      this.state = {};
    };
    E.debug = function () {
      window.setdb = E;
    };
    return E;
  });
})();